import styled, { css } from 'styled-components';
import { palette } from '../../styles/colors';
import { layout } from '../../styles/layout';
import { StandardizedParagraphSizeProps } from '../typography/paragraph.styles';

export interface StyledLinkBrandedProps extends StandardizedParagraphSizeProps {
  weight?: 'normal' | 'bold';
  justify?: 'stretch' | 'center' | 'left' | 'right';
  size?: string;
  sizeLg?: string;
  sizeSubLg?: string;
  sizeMd?: string;
  sizeSm?: string;
  sizeXs?: string;
  backgroundColor?: string;
  textColor?: string;
  noDefaultSizes?: boolean;
}

export const StyledLinkBranded = styled.a<StyledLinkBrandedProps>`
  font-size: ${({ size }) => (size ? size : '1rem')};
  display: inline-block;
  text-decoration: none;
  padding: 0.785em 2.125em;
  color: ${({ textColor }) => textColor ?? 'white'};
  background-color: ${({ backgroundColor }) => backgroundColor || palette.deepPurple};
  font-weight: ${({ weight }) => (weight === 'bold' ? '700' : '400')};
  align-self: center;
  border-radius: 4px;
  text-align: center;
  position: relative;
  justify-self: ${({ justify }) => justify || 'stretch'};
  box-sizing: border-box;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  ${({ noDefaultSizes }) =>
    noDefaultSizes
      ? css`
          line-height: 20px;
        `
      : css`
          height: 45.5px;
          max-width: 240px;
          min-width: 240px;
          line-height: 20px;
        `}

  &:hover {
    -webkit-filter: brightness(85%);
    filter: brightness(85%);
  }

  span {
    align-self: center;
    white-space: pre-wrap;
  }

  ${({ sizeLg }) =>
    !sizeLg
      ? ''
      : `
    @media all and (max-width: ${layout.lg}) {
        font-size: ${sizeLg}};
        line-height: calc(${sizeLg} + 4px);
    }`}
  ${({ sizeSubLg }) =>
    !sizeSubLg
      ? ''
      : `
    @media all and (max-width: ${layout.subLg}) {
        font-size: ${sizeSubLg}};
        line-height: calc(${sizeSubLg} + 4px);
    }`}
  ${({ sizeMd }) =>
    !sizeMd
      ? ''
      : `
    @media all and (max-width: ${layout.md}) {
        font-size: ${sizeMd};
        line-height: calc(${sizeMd} + 4px);
    }`}
  ${({ sizeSm }) =>
    !sizeSm
      ? ''
      : `
    @media all and (max-width: ${layout.sm}) {
        font-size: ${sizeSm};
        line-height: calc(${sizeSm} + 4px);
    }`}
  ${({ sizeXs }) =>
    !sizeXs
      ? ''
      : `
    @media all and (max-width: ${layout.xs}) {
        font-size: ${sizeXs};
        line-height: calc(${sizeXs} + 4px);
    }`}
`;
